import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getLatestContacts } from '../reduxes/slices/contacts/selectors'

export const useIsContactInLatest = () => {
  const latestContacts = useSelector<any, any>(getLatestContacts)

  return useCallback(
    (handle) => {
      const handles = latestContacts.map(
        (contact: { handle: string }) => contact.handle,
      )
      return handles.includes(handle)
    },
    [latestContacts],
  )
}
